import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'ngx-confirm-role-dialog',
    templateUrl: 'confirm-role-dialog.component.html',
    styleUrls: ['confirm-role-dialog.component.scss'],
})
export class ConfirmRoleDialogComponent {
    @Input() role: string;
    isMain = false;

    constructor(protected ref: NbDialogRef<ConfirmRoleDialogComponent>) {
    }

    ngAfterViewInit(): void {
        document.getElementById("yesButton").focus();
    }

    dismiss(value: boolean) {
        if (value) {
            this.ref.close({ isMain: this.isMain });
        } else {
            this.ref.close(value);
        }
    }
}
